module.exports = __webpack_public_path__ + "static/media/beranda.f9456591.png";